import assertNever from 'assert-never';
import { Guid } from '@ef-carbon/primitive';
import Type from './Type';
import isIterable from '../isIterable';
import isIDirect from './isIDirect';
import isIRandom from './isIRandom';
import isIRemote from './isIRemote';
import Direct from './Direct';
import Random from './Random';
import Remote from './Remote';
function confirmNever(_) {
    return false;
}
function isINested(value) {
    if (value === null || typeof value !== 'object') {
        return false;
    }
    const link = value;
    if (isIDirect(link) || isIRandom(link) || isIRemote(link)) {
        return true;
    }
    return confirmNever(link);
}
function create(link) {
    if (!isINested(link)) {
        return new Guid(link);
    } else if (isIDirect(link)) {
        return new Direct(link);
    } else if (isIRandom(link)) {
        return new Random(link);
    } else if (isIRemote(link)) {
        return new Remote(link);
    } else {
        return assertNever(link);
    }
}
export class LinkConditional {
    constructor({conditions, fallback, redirect}) {
        this.type = Type.Conditional;
        const iterable = isIterable(conditions) ? conditions : Object.entries(conditions);
        this.conditions = {};
        for (const [condition, link] of iterable) {
            this.conditions[condition] = create(link);
        }
        this.fallback = create(fallback);
        this.redirect = redirect ? new Guid(redirect) : undefined;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.writable = false;
        descriptors.type.configurable = false;
        descriptors.conditions.configurable = false;
        descriptors.fallback.configurable = false;
        descriptors.redirect.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export {
    LinkConditional as Conditional
};
export const klass = LinkConditional;
export default LinkConditional;    //# sourceMappingURL=Conditional.js.map
